import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

const TermsAndConditions = ({ content, accepted, onAcceptChange, error }) => {
  return (
    <div className="space-y-2">
      <div className="border rounded-lg p-4 max-h-48 overflow-y-auto">
        <h3 className="font-semibold mb-2">Terms and Conditions</h3>
        <div 
          className="text-sm text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="terms"
          checked={accepted}
          onCheckedChange={onAcceptChange}
        />
        <Label htmlFor="terms" className="text-sm">
          I accept the terms and conditions
        </Label>
      </div>
      
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  )
}

export default TermsAndConditions